import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../auth";
import { registerFcmToken, subscribeForegroundMessages } from "../../services/fcmService";

/**
 * Registers FCM token after login and shows foreground push as toasts.
 */
export default function FcmBootstrap() {
  const user = useSelector(selectUser);

  useEffect(() => {
    if (!user?.uid) return undefined;

    registerFcmToken(user.uid);
    const unsub = subscribeForegroundMessages();
    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, [user?.uid]);

  return null;
}
